import React, { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './FoodManualAdd.module.css';
import iconCamera from '../../../../images/common/i_camera_blue.svg';
import iconExclam from '../../../../images/common/i_exclamation_mark_revers.svg';
import axiosApi from '../../../../api/daonAxios';
import ToastPopup from '../../../../components/comm/ToastPopup'

const UNITS = ['g', 'ml'];

const NUTRITION_FIELDS = [
    { key: 'energy', label: '칼로리', unit: 'kcal'},
    { key: 'sodium', label: '나트륨', unit: 'mg'},
    { key: 'protein', label: '단백질', unit: 'g'},
    { key: 'carbohydrate', label: '탄수화물', unit: 'g'},
    { key: 'fat', label: '지방', unit: 'g'},
];

const FoodManualAdd = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const { state } = location;

    const saveGbn = state?.saveGbn;
    const ntktmTyCd = state?.ntktmTyCd;
    const recDe = state?.recDe;

    const foodLensId = state?.foodLensId;

    const [foodName, setFoodName] = useState('');
    const [amount, setAmount] = useState('');
    const [unit, setUnit] = useState('g');
    const [nutrition, setNutrition] = useState({ energy: '', sodium: '', protein: '', carbohydrate: '', fat: '' });
    const [delAt, setDelAt] = useState("1");

    const [counts, setCounts] = useState('');

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const isValid = foodName.trim() && amount && counts.trim();

    const handleSubmit = useCallback(async () => {
        if (!foodName.trim()) return;
        if (!amount) return;
        if (!counts.trim()) return;

        const data = {
            foodName: foodName.trim(),
            servingSize: Number(amount),
            unit,
            counts: counts.trim(),

            energy: nutrition.energy ? Number(nutrition.energy.replace(',', '.')) : 0,
            sodium: nutrition.sodium ? Number(nutrition.sodium.replace(',', '.')) : 0,
            protein: nutrition.protein ? Number(nutrition.protein.replace(',', '.')) : 0,
            carbohydrate: nutrition.carbohydrate ? Number(nutrition.carbohydrate.replace(',', '.')) : 0,
            fat: nutrition.fat ? Number(nutrition.fat.replace(',', '.')) : 0,

            delAt
        };
        
        try {
            const jToken = localStorage.getItem('jToken');

            const res = await axiosApi.post(
                '/diet/myFoodCnddte',
                data,
                {
                    headers: {
                        Authorization: `Bearer ${jToken}`,
                    }
                }
            );

            if (res.status === 200) {
                const myFoodCnddteId = res.data.result;

                if(saveGbn === 'U') {
                    // 음식 변경일때
                    changeFoodLensMyFood(myFoodCnddteId);
                } else {
                    // 음식 추가일때
                    saveFoodLensMyFood(ntktmTyCd, recDe, myFoodCnddteId)
                }
            }
        } catch (err) {
            console.error('음식 직접 기록 저장 중 오류:', err);
        }
    },[saveGbn, ntktmTyCd, recDe, foodLensId, foodName, amount, unit, counts, nutrition, delAt]);

    const handleNutritionChange = (key, val) => {
        const cleaned = val
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1');

        setNutrition(prev => ({
            ...prev,
            [key]: cleaned
        }));
    };

    //내 음식 저장/변경
    const saveFoodLensMyFood = useCallback(async(ntktmTyCd, recDe, myFoodCnddteId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.post('/diet/saveFoodLensMyFood', {ntktmTyCd : ntktmTyCd, recDe : recDe, myFoodCnddteId : myFoodCnddteId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(URL.FOOD_RECORD_DETAIL, {state: {ntktmTyCd : ntktmTyCd, recDe : recDe}});
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })

    },[ntktmTyCd, recDe])


    const changeFoodLensMyFood = useCallback(async(myFoodCnddteId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.put('/diet/changeFoodLensMyFood', {foodLensId : foodLensId, myFoodCnddteId : myFoodCnddteId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(-2);
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })
    },[foodLensId])

    return (
        <>
            <HeadSub title="음식 직접 기록" />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" style={{ paddingBottom: '12rem' }}>

                    {/* 음식 이름 */}
                    <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>
                            음식 이름 <span className={style.badge}>필수</span>
                        </label>
                        <div className={style.inputBox}>
                            <input type="text" placeholder="음식 이름을 입력해주세요"
                                value={foodName} onChange={e => setFoodName(e.target.value)} />
                        </div>
                    </div>

                    {/* 용량 */}
                    <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>
                            용량 <span className={style.badge}>필수</span>
                        </label>
                        <div className={style.amountRow}>
                            <div className={style.inputBox}>
                                <input type="number" inputMode="numeric" placeholder="0"
                                    value={amount} onChange={e => setAmount(e.target.value)} />
                            </div>
                            <div className={style.unitSelect}>
                                <select value={unit} onChange={e => setUnit(e.target.value)}>
                                    {UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* 단위 */}
                    <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>
                            단위 <span className={style.badge}>필수</span>
                        </label>
                        <div className={style.inputBox}>
                            <input
                                type="text"
                                placeholder="예: 접시"
                                value={counts}
                                onChange={e => setCounts(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* 영양소 정보 */}
                    <div className={style.fieldGroup}>
                        <div className={style.nutritionHeader}>
                            <label className={style.fieldLabel}>영양소 정보</label>
                            <span className={style.perServing}>1인분 기준</span>
                        </div>

                        {/* <button className={style.scanBtn} type="button">
                            <span className={style.scanIcon}>
                                <img src={iconCamera} alt="영양성분표 스캔아이콘" />
                            </span>
                            <span>영양성분표 스캔하여 입력</span>
                        </button> */}

                        <div className={style.nutritionList}>
                            {NUTRITION_FIELDS.map(f => (
                                <div key={f.key} className={style.nutritionRow}>
                                    <span className={style.nutritionLabel}>
                                        {f.label}
                                        {/* {f.important && <em className={style.importantBadge}>중요</em>} */}
                                    </span>

                                    <div className={style.rightBox}>
                                        <div className={style.nutritionInput}>
                                            <input type="text" inputMode="decimal" placeholder="0"
                                                value={nutrition[f.key]}
                                                onChange={e => handleNutritionChange(f.key, e.target.value)} />
                                        </div>
                                        <span className={style.nutritionUnit}>{f.unit}</span>
                                    </div>
                                    
                                </div>
                            ))}
                        </div>

                        <p className={style.notice}>
                            <span className={style.noticeIcon}>
                                <img src={iconExclam} alt="참고" />
                            </span>
                            영양성분표를 참고하여 입력해주세요.
                        </p>
                    </div>

                    {/* 내 음식에 저장 */}
                    <div className={style.saveRow}>
                        <div className="chkbox-custom" data-chkbox="basic">
                            <input
                                type="checkbox"
                                id="require-chk1"
                                checked={delAt === "0"}
                                onChange={(e) => setDelAt(e.target.checked ? "0" : "1")}
                            />
                            <label htmlFor="require-chk1"><div className={style['txt-box']}><strong>내 음식에 저장하기</strong></div></label>
                        </div>
                        <span className={style.saveDesc}>다음에도 사용</span>
                    </div>
                </div>
            </div>

            {/* 하단 버튼 */}
            <div className={style.bottomFixed}>
                <button className={style.submitBtn} type="button" disabled={!isValid} onClick={handleSubmit}>
                    추가하기
                </button>
            </div>
            {toast && <ToastPopup setToast={setToast} message={toastMessage} position="center" opacity="90" />}
        </>
    );
};

export default FoodManualAdd;